/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './orders.module.scss';
import Order from './order';
import { useAppState } from '../../../../states/app-state';
import { TReservedOrderDetails } from '../../../../states/reservedOrdersState/models/reservedOrderDetails';
import { observer } from "mobx-react-lite";
import { useThemeMode } from '../../../../states/contexts/theme';

const Orders: React.FC = observer(() => {
    const appState = useAppState();
    const { reservedOrdersList, search, searchItems } = appState.ReservedOrders;
    const filteredOrders = reservedOrdersList?.filter((order: TReservedOrderDetails) => {
        if (!search) return true;
        return (
            (searchItems?.destination_address && String(order.destination_address)?.toLowerCase().includes(search?.toLowerCase()))
            || (searchItems?.destination_details && String(order.destination_details)?.toLowerCase().includes(search?.toLowerCase()))
            || (searchItems?.client_order_number && String(order?.client_order_number)?.toLowerCase().includes(search?.toLowerCase()))
            || (searchItems?.recipient_name && String(order.recipient_name)?.toLowerCase().includes(search?.toLowerCase()))
            || (searchItems?.recipient_phone_number && String(order.recipient_phone_number)?.toLowerCase().includes(search?.toLowerCase()))
        )
    })
    // console.log('filteredOrders', filteredOrders);
    const no_orders = filteredOrders?.length === 0 || !filteredOrders;
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={`${styles.orders} ${no_orders ? styles.no_orders_part : ''}`} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            {filteredOrders?.map((r: TReservedOrderDetails) => <Order key={r?.transport_id} reservedOrderInfo={r} />)}
            {no_orders &&
                <div className={styles.no_orders}>
                    <section>
                        {
                            theme === 'dark' ?
                                <img src="/no-item-reserved-orders-white.svg" alt="" width={155} height={155} />
                                :
                                <img src="/no-item-reserved-orders.svg" alt="" width={155} height={155} />
                        }
                        <p className={styles.no_items}>No items to show.</p>
                        <p className={styles.no_search}>There are no items based on your search</p>
                    </section>
                </div>
            }
        </div>
    )
})
export default Orders;